import { faBadgeCheck, faCheckCircle, faClock } from "@fortawesome/pro-regular-svg-icons";
import {
  faBell,
  faBuilding,
  faCalendarAlt,
  faCheck,
  faCircleHalfStroke,
  faCopy,
  faDownload,
  faEuroSign,
  faEye,
  faFileChartColumn,
  faFileContract,
  faFilter,
  faGauge,
  faPaperPlane,
  faPiggyBank,
  faSearch,
  faTimes,
  faUser,
  faUsers,
  faUserTie
} from "@fortawesome/pro-solid-svg-icons";

const icons = [
  faUsers,
  faUser,
  faSearch,
  faFileContract,
  faBuilding,
  faPaperPlane,
  faEuroSign,
  faCheck,
  faTimes,
  faCalendarAlt,
  faDownload,
  faUserTie,
  faPiggyBank,
  faCheckCircle,
  faClock,
  faBell,
  faBadgeCheck,
  faCircleHalfStroke,
  faCopy,
  faFilter,
  faGauge,
  faFileChartColumn,
  faEye
];

const aliases = {
  notification: "fas fa-bell",
  theme: "fas fa-circle-half-stroke",
  filter: "fas fa-filter",

  user: "fas fa-user",
  search: "fas fa-search",
  dashboard: "fas fa-gauge",

  true: "fas fa-check",
  false: "fas fa-times",

  calender: "fas fa-calendar-alt",
  download: "fas fa-download",
  copy: "fas fa-copy",
  open: "fas fa-eye",

  waiting: "far fa-clock",
  done: "far fa-check-circle",

  tasksDone: "far fa-badge-check",
  statisticReport: "fas fa-file-chart-column"
};

export default {
  aliases,
  icons
};
